import {
  Autocomplete,
  Button,
  ButtonGroup,
  Divider,
  Grid,
  Stack,
  TextField
} from "@mui/material";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
//
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Box } from "@mui/system";
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState
} from "react";
import { confirmAlert } from "react-confirm-alert"; // Import
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import BillTransaction from "./BillTransaction";

const axios = require("axios").default;

const BillCalculation = forwardRef((props, ref) => {
  const { refreshBillList, refreshDueBillList } = { ...props };
  //                                                                redux
  const cartItems = useSelector((state) => state.cartItems);
  const transactionList = useSelector((state) => state.transactionList);
  const isNewPatient = useSelector((state) => state.isNewPatient);
  const patientId = useSelector((state) => state.patientId);
  const orderId = useSelector((state) => state.orderId);
  const paid = useSelector((state) => state.paid);
  const discount = useSelector((state) => state.discount);
  const dispatch = useDispatch();
  //                                                                redux
  //                                                                State Mangement
  const [totalBill, setTotalBill] = useState(0);
  const [payable, setPayable] = useState(0);
  const [balance, setBalance] = useState(0);
  const [preDue, setPreDue] = useState(0);
  const [paymentType, setPaymentType] = useState("Cash");
  //                                                                State Mangement //

  //                                                                reset form
  useImperativeHandle(ref.billCalculationReset, () => ({
    resetFormBillCalculation,
  }));
  //                                                                reset form
  const resetFormBillCalculation = () => {
    // clear cart items.
    dispatch({
      type: "cartItems_reset",
    });
    setPaymentType("Cash");
  };

  //                                                                reset form //

  // Methods Mangement
  const removeItemFromCart = (index) => {
    // const cartItemsArray = [...cartItems];
    // cartItemsArray.splice(index, 1);
    // console.log("cartItemsArray-", cartItemsArray);
    // console.log("cartItems-", cartItems);
    dispatch({
      type: "cartItems_remove",
      payload: index,
    });
  };
  /**
   * if accept over payment is 0 then max current invoice amount can only paid
   */
  const billAcceptOverPayment = () => {
    let settingValue = false;
    if (settingValue === true) {
      return true;
    } else {
      return false;
    }
  };

  const validationRule = () => {
    // let invoicePayable = 0;
    const invoicePayable = totalBill - (discount || 0);
    // Not accept paid amount more then current invoice
    if (paid > invoicePayable && billAcceptOverPayment() === false) {
      console.error(
        "Invoice payable is :" +
          invoicePayable +
          " | More then invoice payable is not accepted."
      );
      toast.error(
        "Invoice payable is :" +
          invoicePayable +
          " | More then invoice payable is not accepted."
      );
      return false;
    } else if (!patientId > 0) {
      toast.error("Patient ID does not found.");
      console.error("Patient ID does not found.");

      return false;
    } else {
      return true;
    }
  };

  // axiso actions
  const refreshTransactionList = (orderId) => {
    axios
      .get("billing-order-transaction/showbyordermasterid/" + orderId)
      .then((response) => {
        console.log("refreshTransactionList", response.data);
        dispatch({
          type: "transactionList_loadData",
          payload: response.data,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const storeBill = () => {
    console.log("discount", typeof discount);

    const orderMaster = {
      total_bill: totalBill,
      discount: discount === null || discount === "" ? 0 : discount,
      total_paid: paid === null || paid === "" ? 0 : paid,
      remarks: "",
      dentrino_patient_info_id: patientId,
    };
    // const orderDetails = [

    // ];
    dispatch({
      type:"isShowBackDrop_update", 
      payload: true
    })
    axios
      .post("/billing-order", { ...orderMaster, cartItems })
      .then((response) => {
        dispatch({
          type:"isShowBackDrop_update", 
          payload: false
        })
        refreshBillList(patientId);
        refreshDueBillList(patientId);
        refreshTransactionList(response.data.data.id);
        console.log(response);
        console.log(response.data.data.id);
        toast.success("Bill saved successfully.");
        dispatch({
          type: "orderId_add",
          payload: response.data.data.id,
        });
        window.open("/bill-print/" + response.data.data.id);
      })
      .catch((error) => {
        dispatch({
          type:"isShowBackDrop_update", 
          payload: false
        })
        console.log(error);
        toast.error("Sometihng is eorror.");
      });
  };

  const handleUpdateBill = () => {
    // console.log("updatebill - ", transactionList);
    // return ;
    const orderMaster = {
      total_bill: totalBill,
      discount: discount,
      total_paid: paid,
      remarks: "",
      dentrino_patient_info_id: patientId,
    };
    // const orderDetails = [

    // ];
    // prepare transaction data
    const newTrasactionList = [];
    transactionList.map((item) => {
      const tempItem = {
        user_id: item.user_id,
        dentrino_clinic_id: item.dentrino_clinic_id,
        // 'dentrino_patient_info_id'=> $request['dentrino_patient_info_id'],
        dentrino_patient_info_id: patientId,
        billing_order_master_id: orderId,
        tr_amount: item.tr_amount,
        payment_type: item.payment_type,
      };
      // console.log("tempItem", tempItem);
      newTrasactionList.push(tempItem);
    });

    console.log("newTrasactionList--", newTrasactionList);
    // return newTrasactionList;

    dispatch({
      type: "isShowBackDrop_update",
      payload: true,
    });
    axios
      .put("/billing-order/" + orderId, {
        orderMaster,
        cartItems,
        billingOrderTransactoins: newTrasactionList,
      })
      .then((response) => {
        dispatch({
          type: "isShowBackDrop_update",
          payload: false,
        });
        console.log("response data-", response);
        console.log(response.data.data.id);
        toast.success("Bill updated successfully.");
        console.log("response data", response.data);
        refreshBillList(patientId);
        refreshDueBillList(patientId);
        window.open("/bill-print/" + orderId);
      })
      .catch((error) => {
        dispatch({
          type: "isShowBackDrop_update",
          payload: false,
        });
        console.log(error);
        toast.error("Sometihng is eorror.");
      });
  };
  // axiso actions //

  // Store Bill
  const handleSaveStoreBill = () => {
    //hello
    //hello
    //hello
    //hello

    if (validationRule() === true) {
      // WITH
      if (paid === "" || paid === null) {
        confirmAlert({
          title: "Confirm Save",
          message:
            "Your are saving bill without any paid amount , do you want to proceed ?",
          buttons: [
            {
              label: "Yes",
              onClick: () => storeBill(),
            },
            {
              label: "No",
              onClick: () => "",
            },
          ],
        });
      }
      else{
        storeBill()
      }
      ///
    } else {
      return alert("Some error happened");
    }
  };
  // Store Bill /
  const printBill = () => {
    if (orderId > 0) {
      window.open("/bill-print/" + orderId);
    } else {
      toast.error("No id found for print.");
    }
  };

  const handleListItemChange = (value, index, filed_name) => {
    dispatch({
      type: "cartItems_handleChange",
      payload: {
        value: value,
        index: index,
        filed_name: filed_name,
      },
    });
  };
  // Methods Mangement End
  // UseEffect Mangement

  useEffect(() => {
    // const cartItemsArray = [...cartItems];
    let total_bill = 0;
    let cartItemCount = 0;
    cartItems.map((cartItem, index) => {
      total_bill += cartItem.mrp * cartItem.qty;
      cartItemCount = cartItemCount + 1;
      // console.log(cartItem.mrp * cartItem.qty);
    });
    // console.log("total_bill-", total_bill);
    // console.log("cartItemCount-", cartItemCount);
    setTotalBill(total_bill);

    if (cartItems.length === 0) {
      // setDiscount(0);
      // setPaid(0);
      dispatch({
        type: "paid_update",
        payload: "",
      });
      dispatch({
        type: "discount_update",
        payload: "",
      });
    }
  }, [cartItems]);

  useEffect(() => {
    if (billAcceptOverPayment() === true) {
      // WITH PREVIOUS DUE
      setPayable(preDue + totalBill - discount);
      setBalance(payable - (paid || 0));
      // this.invoice.payable =  parseInt(this.invoice.preDue) + parseInt(this.invoice.bill) - (parseInt(this.invoice.discount) || 0);
      // this.invoice.balance =parseInt(this.invoice.payable) - (parseInt(this.invoice.paid) || 0);
    } else {
      // console.log("insdie no - billAcceptOverPayment")
      setPayable(totalBill - discount);
      setBalance(totalBill - discount - (paid || 0));
    }
  }, [totalBill, paid, discount]);
  // UseEffect Mangement End

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#E7EBF0",
      color: theme.palette.common.black,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 10,
    },
  }));

  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
  }));

  // backdrop

  // backdrop

  return (
    <>
      {/* toast container  */}
      <ToastContainer />

      {/* toast container  */}
      {/* ------------------------------------------------------------- PRICE CHART  */}

      <TableContainer
        id="billCalulation"
        component={Paper}
        style={{ height: 300 }}
      >
        <Table stickyHeader sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <StyledTableCell>ID</StyledTableCell>
              <StyledTableCell align="right">Service Name</StyledTableCell>
              <StyledTableCell align="right">Price</StyledTableCell>
              <StyledTableCell align="right">Qty</StyledTableCell>
              <StyledTableCell align="right">Total Price</StyledTableCell>
              <StyledTableCell align="right">Remove</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cartItems.map((cartItem, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {cartItem.id}
                </TableCell>
                <TableCell align="left" sx={{ py: 1, maxWidth: 220 }}>
                  <TextField
                    autoComplete="off"
                    size="small"
                    value={cartItem.service_name}
                    onChange={(e) =>
                      handleListItemChange(
                        e.target.value,
                        index,
                        "service_name"
                      )
                    }
                  />
                </TableCell>
                <TableCell align="right" sx={{ maxWidth: 120, py: 1 }}>
                  <TextField
                    autoComplete="off"
                    size="small"
                    type="number"
                    value={parseInt(cartItem.mrp)}
                    onChange={(e) =>
                      handleListItemChange(e.target.value, index, "mrp")
                    }
                  />
                </TableCell>
                <TableCell align="right">{cartItem.qty}</TableCell>
                <TableCell align="right">
                  {cartItem.mrp * cartItem.qty}
                </TableCell>
                <TableCell align="right">
                  <Button
                    onClick={() => removeItemFromCart(index)}
                    variant="outlined"
                    color="error"
                    size="small"
                  >
                    X
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {/* ------------------------------------------------------------- PRICE CHART END */}
      {/* ------------------------------------------------------------- Total Calculation */}
      <Box sx={{ pt: 2 }}>
        <Grid container spacing={2}>
          <Grid item xs={6} md={4}>
            <Autocomplete
              required
              id="size-small-outlined"
              size="small"
              options={["Cash", "Card", "Bkash", "Rocket", "Nagad"]}
              defaultValue="Cash"
              value={paymentType}
              onChange={(e, value) => {
                setPaymentType(value);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Payment Methods" />
              )}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <TextField
              readOnly
              autoComplete="off"
              label="Total Bill"
              id="outlined-size-normal"
              size="small"
              value={totalBill}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            <TextField
              type="number"
              autoComplete="off"
              label="Discount"
              id="outlined-size-normal"
              size="small"
              onChange={(e) =>
                dispatch({
                  type: "discount_update",
                  payload: e.target.value,
                })
              }
              // onChange={(event) => setDiscount(event.target.value)}
              value={discount}
            />
          </Grid>
          {/* 2nd ROW */}
          <Grid item xs={6} md={4}>
            <TextField
              readOnly
              autoComplete="off"
              label="Payable"
              id="outlined-size-normal"
              size="small"
              value={payable}
            />
          </Grid>
          <Grid item xs={6} md={4}>
            {orderId ? (
              <TextField
                readOnly
                type="number"
                autoComplete="off"
                label="Paid"
                id="outlined-size-normal"
                size="small"
                // onChange={(e) => setPaid(e.target.value)}
                value={paid}
              />
            ) : (
              <TextField
                type="number"
                autoComplete="off"
                label="Paid"
                id="outlined-size-normal"
                size="small"
                onChange={(e) =>
                  dispatch({
                    type: "paid_update",
                    payload: e.target.value,
                  })
                }
                // onChange={(e) => setPaid(e.target.value)}
                value={paid}
              />
            )}
          </Grid>
          <Grid item xs={6} md={4}>
            <TextField
              readOnly
              autoComplete="off"
              label="Balance"
              id="outlined-size-normal"
              size="small"
              value={balance}
            />
          </Grid>
          {/* 2nd ROW END */}

          {/* 3rd ROW  */}
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} md={9}>
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  width: "100%",
                  bgcolor: "#E7EBF0",
                  borderRadius: 2,
                  mb: 2,
                  py: 2,
                  px: 2,
                  mx: 2,
                }}
              >
                <Stack
                  direction="row"
                  divider={<Divider orientation="vertical" flexItem />}
                  spacing={1}
                >
                  <Item>Pre.Due : {preDue} </Item>
                  <Item>Curr. Bill : {totalBill} </Item>
                  <Item>
                    Total (Pre. Due + Curr. Inv.) : {preDue + totalBill}
                  </Item>
                </Stack>
                <Box sx={{ mt: 2 }}>
                  <Stack
                    direction="row"
                    divider={<Divider orientation="vertical" flexItem />}
                    spacing={2}
                  >
                    <Item>DISCOUNT : {discount} </Item>
                    <Item>PAID : {paid} </Item>
                    <Item>Balance : {balance} </Item>
                  </Stack>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} md={3}>
              <ButtonGroup
                sx={{
                  display: "flex",
                  pl: 2,
                  justifyContent: "center",
                  height: "100%",
                }}
                orientation="vertical"
                aria-label="vertical outlined button group"
              >
                {!orderId && (
                  <Button
                    key="billStore"
                    variant="contained"
                    color="success"
                    onClick={handleSaveStoreBill}
                  >
                    SAVE
                  </Button>
                )}
                {orderId && (
                  <>
                    <Button
                      key="billUpdate"
                      variant="contained"
                      color="success"
                      onClick={handleUpdateBill}
                    >
                      UPDATE
                    </Button>
                    <Button
                      key="billPrint"
                      variant="contained"
                      color="warning"
                      onClick={printBill}
                    >
                      PRINT
                    </Button>
                  </>
                )}
              </ButtonGroup>
            </Grid>
          </Grid>

          {/* 3rd ROW END */}
          {/* transactin list  */}
          <BillTransaction></BillTransaction>

          {/* transactin list  */}
        </Grid>
        <div></div>
      </Box>
      {/* ------------------------------------------------------------- Total Calculation */}
    </>
  );
});

export default BillCalculation;
